// CUSTOM (Jorico): keyboard and Japanese input fixes for vendor components. Loaded by sections/header.liquid on every page.

// 1. Escape closes an open header dropdown / mega menu and returns focus to its menu item.
// The vendor's header dropdowns have no focus trap (HeaderDropdownMenu.trapStack is empty), and the trap is where the other
// dialogs handle Escape, so a menu opened from the keyboard could only be left by tabbing through it.
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape' || event.isComposing) return;

  const menu = document.querySelector('header-dropdown-menu[open], header-mega-menu[open]');
  if (!menu || typeof menu.hide !== 'function') return;

  const activator = document.querySelector(`[aria-controls="${menu.id}"]`);
  menu.hide();
  activator?.focus();
});

// 2. IME: the vendor predictive search fires on every input event, so it searched the unconverted kana while a word was still
// being composed (「ぶ」, 「ぶら」 before 「ブラ」). Hold those events back during composition and send one when it ends.
const searchField = (target) => target instanceof HTMLInputElement && target.name === 'q' && target.form?.hasAttribute('aria-owns');

document.addEventListener('input', (event) => {
  if (event.isComposing && searchField(event.target)) event.stopImmediatePropagation();
}, true);

document.addEventListener('compositionend', (event) => {
  if (searchField(event.target)) event.target.dispatchEvent(new Event('input', { bubbles: true }));
}, true);

// 3. On phones the product gallery is a sideways scroller with nothing focusable in it (the zoom buttons are hidden there), so keyboard
// users could not scroll it. Make it focusable only while it actually scrolls (on desktop it is a grid and gets no extra tab stop).
const syncGalleryFocus = () => {
  document.querySelectorAll('.product-gallery__carousel').forEach((gallery) => {
    if (gallery.scrollWidth > gallery.clientWidth + 1) gallery.tabIndex = 0;
    else gallery.removeAttribute('tabindex');
  });
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncGalleryFocus);
else syncGalleryFocus();
window.addEventListener('resize', syncGalleryFocus);
